import { toggleBlocking } from "../store/actions";
import store from "../store/configureStore";

let stack = [];
let requestCounter = 0; 

export const addToStack = (urlRequest) => {
  const requestId = requestCounter++; 
  stack.push({ id: requestId, url: urlRequest }); 
  setBlocking();
  return requestId; 
};

export const removeFromStack = (requestId) => {
  if (stack.length > 0) {
    stack = stack.filter((item) => item.url !== requestId);
    setBlocking();
  }
};

const setBlocking = () => {
  const isBlocking = stack.length > 0;

  if (store.getState().blocking !== isBlocking) {
    store.dispatch(toggleBlocking(isBlocking));
  }
};
